import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DownloadInvoiceRoutingModule } from './download-invoice-routing.module';
import { DownloadInvoiceComponent } from './download-invoice.component';
import { ControlsModule } from 'src/app/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';


@NgModule({
  declarations: [
    DownloadInvoiceComponent
  ],
  imports: [
    CommonModule,
    DownloadInvoiceRoutingModule,
    ControlsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ReusableModule,
  ]
})
export class DownloadInvoiceModule { }
